import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'
import type { StatsOverview } from './types'

export const STATS_QUERY_KEY = ['stats', 'overview'] as const

export function useStatsOverview(tenantIds?: string[]) {
  const tenantKey = tenantIds ? [...tenantIds].sort().join(',') : ''
  return useQuery<StatsOverview>({
    queryKey: [...STATS_QUERY_KEY, tenantKey],
    queryFn: (): Promise<StatsOverview> => {
      const params = tenantIds && tenantIds.length > 0
        ? `?tenantIds=${tenantIds.join(',')}`
        : ''
      return api.get(`/stats/overview${params}`).then((r: { data: StatsOverview }) => r.data)
    },
    staleTime: 60_000,
    refetchInterval: 120_000,
  })
}
